import React, { useState } from 'react';

import Table from '~components/molecules/Table';

import { useAppDispatch, useAppSelector } from '~redux/hooks';

import * as Styles from './CustomerTransferTable.module.scss';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import ActionButton from '~components/atoms/ActionButton';
import UtilFunctions from '~utils/functions';
import { MetalTypeEnum, TransactionStatusEnum } from '~utils/enums';
import Chip from '~components/atoms/Chip';
import combinedActions from '~redux/combinedActions';
import { TCustomerTransferListing, TGetCustomerDetailsData } from '~types/feat/customerTransfer';

const CustomerTransferTable = () => {
    const dispatch = useAppDispatch();
    const { Misc: { dateTimeFormat } } = UtilFunctions;

    const customerTransferListing = useAppSelector(state => state.customerTransfer.customerTransferListing.data);

    const customerTransferListingIndex = useAppSelector(state => state.customerTransfer.customerTransferListing.index);
    const isLoading = useAppSelector(state => state.customerTransfer.loadings.getCustomerTransferListing);
    const isError = useAppSelector(state => state.customerTransfer.errors.getCustomerTransferListing);

    const setSelectedCustomerTransferTransaction = (transaction: TCustomerTransferListing) => dispatch(combinedActions.customerTransferSetSelectedCustomerTransfer(transaction));

    const setIsCustomerTransferDetailsModalOpen = (isOpen: boolean) => {dispatch(combinedActions.customerTransferSetIsCustomerTransferDetailsModalOpen(isOpen));};

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    const handleViewTransaction = (transaction: TCustomerTransferListing) => {
        dispatch(combinedActions.customerTransferGetCustomerTransferDetailsAttempt({ id: transaction.customerTransferId }));
        setIsCustomerTransferDetailsModalOpen(true);
    };

    const tableHeader = [
        'TRANSACTION ID',
        'SENDER NAME',
        'SENDER CIF',
        'PRODUCT NAME',
        'METAL TYPE',
        'SERIAL NUMBER',
        'TOTAL WEIGHT (G)',
        'STATUS',
        'RECEIVER NAME',
        'RECEIVER CIF',
        'BRANCH CODE',
        'BRANCH NAME',
        'REGION NAME',
        'BRANCH TELLER NAME',
        'SALES PERSONNEL NAME',
        'REFERRAL NAME',
        'TRANSACTION DATE',
        'ACTION',
    ];

    const tableBody = customerTransferListing.map(customerTransfer => {
        const {
            customerTransferId,
            senderName,
            senderCIFNo,
            productName,
            metalType,
            serialNumbers,
            weight,
            status,
            receiverName,
            receiverCIFNo,
            branchCode,
            branchName,
            regionName,
            branchTellerName,
            salesPersonnelName,
            referralName,
            createdAt,
        } = customerTransfer;

        const handleViewSerialNo = () => {
            if (!serialNumbers) return;

            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNumbers);
        };

        const renderSerialNo = () => {
            if (!serialNumbers) return '-';

            return (
                <ActionButton
                    testId='customerTransfer-view-serialNo-modal-button'
                    key={customerTransferId}
                    label='View'
                    onClick={() => handleViewSerialNo()}
                />
            );
        };

        const renderStatusChip = (statusValue: TransactionStatusEnum, label: string) => {
            switch (statusValue) {
                case TransactionStatusEnum.Pending: {
                    return (
                        <Chip
                            type='warning'
                            label={label}
                        />
                    );
                }

                case TransactionStatusEnum.Approved: {
                    return (
                        <Chip
                            type='success'
                            label={label}
                        />
                    );
                }

                case TransactionStatusEnum.Rejected: {
                    return (
                        <Chip
                            type='error'
                            label={label}
                        />
                    );
                }

                default: return <Chip label={label} />;
            }
        };

        return {
            className: Number(metalType) === MetalTypeEnum.Gold
                ? Styles['gold-row']
                : '',
            cells: [
                customerTransferId,
                senderName,
                senderCIFNo,
                productName,
                MetalTypeEnum[metalType],
                renderSerialNo(),
                weight !== null && weight !== undefined
                    ? weight.toFixed(3)
                    : '-',
                renderStatusChip(status, TransactionStatusEnum[status]),
                receiverName,
                receiverCIFNo,
                branchCode,
                branchName,
                regionName,
                branchTellerName || '-',
                salesPersonnelName || '-',
                referralName || '-',
                dateTimeFormat(createdAt) || '-',
                (
                    <div key={`action-${customerTransferId}`} className={Styles['action-button-container']}>
                        <div>
                            <ActionButton
                                label='View Details'
                                onClick={() => handleViewTransaction(customerTransfer)}
                            />
                        </div>
                    </div>
                ),
            ],
        };
    });

    return (
        <>
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoading}
                error={isError}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />

        </>

    );
};

export default CustomerTransferTable;
